import React from "react";
import {Box, TextField} from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DateTimePicker} from "@mui/x-date-pickers/DateTimePicker";

// Components
import {LoadingDialog} from "../../../../components/DialogLoading";
import {TwoButtonDialog} from "../../../../designSystem/components/TwoButtonDialog";
import {ActionButton} from "../../../../designSystem/components/ActionButton";
import {MeasureForm} from "../MeasureForm";

export enum ADD_MEASURE_MODAL_CONTENTS {
  LOADING = 'loading',
  ADDED = 'added',
  FORM = 'form',
}

export const AddMeasureModalContent = ({
  isValid,
  measureDateTime,
  measurement,
  submitMeasurement,
  selectedMetric,
  onCloseDialog,
  onClickGoToVisualization,
  onChangeMeasurement,
  onChangeMeasureDateTime,
}) => ({
  [ADD_MEASURE_MODAL_CONTENTS.LOADING]: (
    <LoadingDialog label="載入中" />
  ),
  [ADD_MEASURE_MODAL_CONTENTS.ADDED]: (
    <TwoButtonDialog
      title="成功新增！"
      leftLabel="再加一筆"
      leftOnClick={onCloseDialog}
      leftIconName="fa-square-caret-right"
      rightLabel="看數據"
      rightOnClick={onClickGoToVisualization}
      rightIconName="fa-chart-simple"
    />
  ),
  [ADD_MEASURE_MODAL_CONTENTS.FORM]: (
    <Box className="fixed bottom-0 left-0 right-0 flex justify-center outline-none">
      {/* 內層你的 bottom sheet 面板 */}
      <Box className="w-[400px] flex flex-col gap-4 bg-white rounded-t-2xl shadow p-8 pb-6">
        <div>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              label="量測時間"
              value={measureDateTime}
              onChange={onChangeMeasureDateTime}
              inputFormat="YYYY/MM/DD HH:mm"
              renderInput={(params) => (
                <TextField {...params} fullWidth size="small"/>
              )}
            />
          </LocalizationProvider>
        </div>
        {MeasureForm({
          measurement,
          onChangeMeasurement,
        })[selectedMetric] || <></>}
        <ActionButton
          onClick={submitMeasurement}
          label="儲存"
          disabled={!isValid}
        />
      </Box>
    </Box>
  )
})